/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItem_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespComplementaryItemsGrid_item$ref: FragmentReference;
export type PdpRespComplementaryItemsGrid_item = {|
  +complementaryItems?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +title: ?string,
        +serviceId: ?string,
        +categoryPath: ?string,
        +categoryCode: ?string,
        +browseUrl: ?string,
        +ecommerceTrackingParams?: ?any,
        +$fragmentRefs: PdpRespSimilarItem_item$ref,
      |}
    |}>
  |},
  +$refType: PdpRespComplementaryItemsGrid_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespComplementaryItemsGrid_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "complementaryItems",
          "storageKey": "complementaryItems(first:12)",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 12,
              "type": "Int"
            }
          ],
          "concreteType": "complementaryItemsConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "complementaryItemsEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Item",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "title",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "serviceId",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "categoryPath",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "categoryCode",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "browseUrl",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "PdpRespSimilarItem_item",
                      "args": null
                    },
                    {
                      "kind": "Condition",
                      "passingValue": true,
                      "condition": "isClient",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "ecommerceTrackingParams",
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "userId",
                              "variableName": "userId",
                              "type": "String"
                            }
                          ],
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cc0d9f89224bd4ac7e5ed99569b17dc7';
module.exports = node;
